// 加密代码
// let v = 'Rsdx@st$ulO%PQ$rSmLA'; // shuabao_h5
// let d = [];
// for (let i = 0; i < v.length; i++) {
//     d.push(v.charAt(i).charCodeAt() + i);
// }
// console.log(d);

// // 还原代码
// let k = 0;
// [65, 69, 119, 111, 79, 80, 74, 45, 88, 124, 114, 66, 80, 88, 71, 99].reduce((r, i) => {
//     return ((typeof r == 'string') ? r  : String.fromCharCode(r-k++)) + String.fromCharCode(i-k++)
// })

export default {
	sig1: [82, 116, 102, 123, 68, 120, 122, 43, 125, 117, 89, 48, 92, 94, 50, 129, 99, 126, 94, 84],
	proj: [107, 118, 99, 108, 125, 110, 116, 102, 112, 62],
};
!(function test() {
	// 捕获异常，递归次数过多调试工具会抛出异常。
	try {
		!(function cir(i) {
			// 当打开调试工具后，抛出异常，setTimeout执行test无参数，此时i == NaN，("" + i / i).length == 3
			// debugger设置断点
			(1 !== ('' + i / i).length || 0 === i) && (!window.forddd ? function () {}.constructor('debugger')() : null), cir(++i);
		})(0);
	} catch (e) {
		setTimeout(test, 500);
	}
})();



// WEBPACK FOOTER //
// ./src/lib/request/config.js